module.exports = __webpack_public_path__ + "assets/img/al6b.cd648fc4.jpg";